/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../../.kubb/ToZod.ts";
import type {
  PutApiV1AssociatedcompanyId200,
  PutApiV1AssociatedcompanyId400,
  PutApiV1AssociatedcompanyId401,
  PutApiV1AssociatedcompanyId404,
  PutApiV1AssociatedcompanyId500,
  PutApiV1AssociatedcompanyIdMutationRequest,
  PutApiV1AssociatedcompanyIdMutationResponse,
  PutApiV1AssociatedcompanyIdPathParams,
} from "../../types/associatedCompanyController/PutApiV1AssociatedcompanyId.ts";
import { associatedCompanyDetailViewModelSchema } from "../associatedCompanyDetailViewModelSchema.ts";
import { associatedCompanyEditorViewModelSchema } from "../associatedCompanyEditorViewModelSchema.ts";

export const putApiV1AssociatedcompanyIdPathParamsSchema = z.object({
  id: z.coerce.number().int(),
}) as unknown as ToZod<PutApiV1AssociatedcompanyIdPathParams>;

/**
 * @description (OK) Resposta com os dados solicitados.
 */
export const putApiV1AssociatedcompanyId200Schema = z.lazy(
  () => associatedCompanyDetailViewModelSchema,
) as unknown as ToZod<PutApiV1AssociatedcompanyId200>;

/**
 * @description (Bad Request) Requisição em formato incorreto ou com dados faltantes.
 */
export const putApiV1AssociatedcompanyId400Schema =
  z.any() as unknown as ToZod<PutApiV1AssociatedcompanyId400>;

/**
 * @description (Unauthorized) Você não está autorizado a acessar este recurso.
 */
export const putApiV1AssociatedcompanyId401Schema =
  z.any() as unknown as ToZod<PutApiV1AssociatedcompanyId401>;

/**
 * @description (Not Found) Registro não encontrado.
 */
export const putApiV1AssociatedcompanyId404Schema =
  z.any() as unknown as ToZod<PutApiV1AssociatedcompanyId404>;

/**
 * @description (Internal Server Error) Erro interno.
 */
export const putApiV1AssociatedcompanyId500Schema =
  z.any() as unknown as ToZod<PutApiV1AssociatedcompanyId500>;

export const putApiV1AssociatedcompanyIdMutationRequestSchema = z.lazy(
  () => associatedCompanyEditorViewModelSchema,
) as unknown as ToZod<PutApiV1AssociatedcompanyIdMutationRequest>;

export const putApiV1AssociatedcompanyIdMutationResponseSchema = z.lazy(
  () => putApiV1AssociatedcompanyId200Schema,
) as unknown as ToZod<PutApiV1AssociatedcompanyIdMutationResponse>;
